import React from 'react';
import { HelpPopover } from './HelpPopover';
import { PreferencesPopover } from './PreferencesPopover';
import { V11UserMenu } from '@/components/v11/auth/V11UserMenu';

interface SidebarFooterProps {
  readonly collapsed: boolean;
}

/**
 * The row of icons above the user card.
 *
 * CT-0 shows four: bell, sparkle, help and the gear. The bell is not here —
 * there is no notification in the product to ring it (AL-1866) — and the
 * sparkle is marked "AINDA NÃO TEMOS" in the file itself. Both are left out
 * rather than drawn dead: an icon that opens an empty panel reads as broken,
 * an icon that is not there promises nothing.
 */
export const SidebarFooter: React.FC<SidebarFooterProps> = ({ collapsed }) => (
  // One 8px rhythm in both widths (AL-1943); the rail used 16px here.
  <div className={`flex flex-col gap-2 ${collapsed ? 'items-center' : ''}`}>
    <div
      className={`flex items-center px-1 ${collapsed ? 'flex-col gap-1' : 'justify-between'}`}
      data-testid="sidebar-footer-icons"
    >
      <HelpPopover />
      <PreferencesPopover />
    </div>

    <V11UserMenu collapsed={collapsed} />
  </div>
);
